import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBCustomerIdentifierSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="cbCustomerId"
            formName="cbCustomerId"
            label="cbCustomerIdentifier"
        />
    )
}

export default CBCustomerIdentifierSearchFilter;